/**
 * Term
 * Vue app for term modals
 */

<template>
  <div>
    <div @click="open" style="cursor: pointer;"><slot name="body"></slot></div>

    <div class="modal" @click="close" :class="{ 'is-viewing': isLoaded && isOpen }">
      <div class="modal-inner" @click.stop="close">
        <div class="pl1">
          <h3 class="dw-ref">{{ code }}</h3>
          <h1 class="dw-title">{{ title }}</h1>
        </div>
        <div class="content content--padded content--c" v-html="content"></div>
        <div class="tac mt1 mb2 pl1 pr1">
          <a class="btn" :href="url">Learn more</a>
        </div>
      </div>
    </div>
    <div class="modal-screen" @click="close"></div>
  </div>
</template>

<script>
import { Vimeo } from '../lib';

module.exports = {
  data() {
    return {
      code: '',
      content: '',
      isLoaded: false,
      isOpen: false,
      title: '',
      url: '',
    };
  },
  props: [
    'term',
  ],
  created: function() {
    const vue = this;
    document.addEventListener('keydown', (e) => {
      if(e.which === 27) {
        vue.close();
      }
    });
  },
  methods: {
    close: function() {
      this.isOpen = false;
      Vimeo.pause();
      document.body.classList.remove('is-modal-viewing');
    },

    open: function() {
      this.isOpen = true;
      this.fetch();
      Vimeo.play();
      document.body.classList.add('is-modal-viewing');
    },

    fetch: function() {
      const vue = this;
      const xhr = new XMLHttpRequest();
      xhr.timeout = 10000;
      const url = `/api/0.1/term/${this.term}`;
      xhr.open('GET', url);
      xhr.send(null);
      xhr.onload = (e) => {
        if (xhr.readyState === 4) {
          if ([200].indexOf(xhr.status) != -1) {
            const data = JSON.parse(xhr.responseText);

            vue.code = data.code;
            vue.content = data.content
              .replace(/\<iframe.+?\>/i, '<div class="video">$&')
              .replace(/\<\/iframe\>/i, '</iframe></div>');
            vue.isLoaded = true;
            vue.title = data.title;
            vue.url = `/design-wise#${this.term}`;
          }
        }
      };
    },
  },
}
</script>



// WEBPACK FOOTER //
// components/Term.vue